module.exports = __webpack_public_path__ + "img/FF_Info_Game_8.6a204631.png";